export function CalgaryEnforcement() {
  const violations = [
    {
      violation: 'Operating without business license',
      penalty: '$500 - $2,000',
      enforcement: 'Daily fines until compliance',
      severity: 'high'
    },
    {
      violation: 'Missing license number in ads',
      penalty: '$500+',
      enforcement: 'Warning then escalating fines',
      severity: 'medium'
    },
    {
      violation: 'Fire safety non-compliance',
      penalty: '$1,000 - $5,000',
      enforcement: 'License suspension',
      severity: 'high'
    },
    {
      violation: 'Exceeding occupancy limits',
      penalty: '$500 - $1,500',
      enforcement: 'Warning then fines',
      severity: 'medium'
    },
    {
      violation: 'Noise or nuisance violations',
      penalty: '$250 - $1,000',
      enforcement: 'Escalating penalties',
      severity: 'low'
    },
    {
      violation: 'False information on application',
      penalty: '$1,000 - $10,000',
      enforcement: 'License revocation',
      severity: 'high'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-[#F0F0F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-[#882629]/10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
            2026 Enforcement
          </span>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Proactive Audit Enforcement
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Calgary conducts proactive audits of STR listings to ensure compliance. Fines of $500+ are issued for missing license numbers in advertisements, and the city actively monitors platforms for unlicensed operators.
          </p>
        </div>

        <div className="mb-16">
          <h3 className="text-2xl font-semibold text-[#505A5A] mb-8 text-center">
            Common Violations &amp; Penalties
          </h3>
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-[#882629] text-white">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold">Violation</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">Penalty Range</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">Enforcement Action</th>
                    <th className="px-6 py-4 text-center text-sm font-semibold">Severity</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[#F0F0F0]">
                  {violations.map((item, index) => (
                    <tr key={index} className="hover:bg-[#F0F0F0]/50 transition-colors">
                      <td className="px-6 py-4 text-sm text-[#505A5A]">{item.violation}</td>
                      <td className="px-6 py-4 text-sm font-semibold text-[#882629]">{item.penalty}</td>
                      <td className="px-6 py-4 text-sm text-[#505A5A]/70">{item.enforcement}</td>
                      <td className="px-6 py-4 text-center">
                        <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                          item.severity === 'critical' ? 'bg-red-100 text-red-800' :
                          item.severity === 'high' ? 'bg-orange-100 text-orange-800' :
                          item.severity === 'medium' ? 'bg-yellow-100 text-yellow-800' :
                          'bg-gray-100 text-gray-800'
                        }`}>
                          {item.severity.toUpperCase()}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="bg-white rounded-2xl p-8 text-center">
            <div className="w-16 h-16 bg-[#882629]/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-search-line text-3xl text-[#882629]"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#505A5A] mb-4">Proactive Platform Audits</h3>
            <p className="text-[#505A5A]/70 leading-relaxed">
              Calgary regularly scans Airbnb, Vrbo, and other platforms to identify listings without proper license numbers displayed.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 text-center">
            <div className="w-16 h-16 bg-[#882629]/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-file-list-3-line text-3xl text-[#882629]"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#505A5A] mb-4">License Verification</h3>
            <p className="text-[#505A5A]/70 leading-relaxed">
              Cross-referencing platform listings with business license database to identify unlicensed operators.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 text-center">
            <div className="w-16 h-16 bg-[#882629]/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-user-voice-line text-3xl text-[#882629]"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#505A5A] mb-4">Complaint Response</h3>
            <p className="text-[#505A5A]/70 leading-relaxed">
              Neighbor complaints are investigated within 48-72 hours with site inspections and enforcement action as needed.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-8 mb-12">
          <h3 className="text-2xl font-semibold text-[#505A5A] mb-6 flex items-center gap-3">
            <i className="ri-information-line text-[#882629] text-3xl"></i>
            Key Compliance Requirements
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h4 className="font-semibold text-[#505A5A] mb-3">License Display</h4>
              <ul className="space-y-2 text-[#505A5A]/70 text-sm">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#882629] mt-1"></i>
                  <span>Display license number prominently in all online listings</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#882629] mt-1"></i>
                  <span>Include license number in property description</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#882629] mt-1"></i>
                  <span>Post physical license certificate at property</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#882629] mt-1"></i>
                  <span>Fines of $500+ for missing license numbers</span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-[#505A5A] mb-3">Ongoing Compliance</h4>
              <ul className="space-y-2 text-[#505A5A]/70 text-sm">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#882629] mt-1"></i>
                  <span>Maintain valid business license at all times</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#882629] mt-1"></i>
                  <span>Keep fire safety equipment current and tested</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#882629] mt-1"></i>
                  <span>Respond promptly to neighbor concerns</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#882629] mt-1"></i>
                  <span>Update license information if property details change</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-[#882629] to-[#6E1F22] rounded-2xl p-8 lg:p-10 text-white shadow-xl">
          <div className="flex flex-col lg:flex-row items-center gap-6">
            <div className="flex-shrink-0">
              <i className="ri-shield-check-line text-6xl"></i>
            </div>
            <div className="flex-grow text-center lg:text-left">
              <h4 className="text-2xl font-bold mb-3">
                Enforcement Style: Proactive Audits
              </h4>
              <p className="text-lg text-white/90 leading-relaxed">
                Calgary conducts proactive audits of STR platforms to identify non-compliant operators. Fines for missing license numbers in ads start at $500+. The city actively monitors listings and cross-references with business license databases to ensure compliance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
